import { useEffect, useState } from 'react'
import { useTar } from '@/modules'

interface InviteHeroPartnerProps {
  organizationName: string
  inviterName?: string
  logoSquareURL?: string | null
}

export const InviteHeroPartner = ({ organizationName, inviterName, logoSquareURL }: InviteHeroPartnerProps) => {
  const { t } = useTar()
  const initial = organizationName.trim().charAt(0).toUpperCase() || '·'
  const [imageError, setImageError] = useState(false)

  useEffect(() => {
    setImageError(false)
  }, [logoSquareURL])

  const showLogo = !!logoSquareURL && !imageError

  return (
    <header className="text-center space-y-5">
      <div className="flex justify-center">
        <div
          className="relative h-14 w-14 rounded-full flex items-center justify-center bg-gradient-to-br from-emerald-500/10 to-emerald-500/0 ring-1 ring-emerald-500/40 overflow-hidden"
          aria-hidden
        >
          {showLogo ? (
            <img
              src={logoSquareURL ?? undefined}
              alt=""
              onError={() => setImageError(true)}
              className="h-10 w-10 object-contain"
            />
          ) : (
            <span className="text-lg font-semibold tracking-wide text-emerald-600 select-none" translate="no">
              {initial}
            </span>
          )}
          <span className="pointer-events-none absolute -inset-1 rounded-full ring-1 ring-emerald-500/10" />
        </div>
      </div>

      <div className="flex items-center justify-center gap-3">
        <span className="h-px w-10 bg-border" aria-hidden />
        <span className="text-[11px] uppercase tracking-[0.22em] text-muted-foreground font-medium">
          {t('invite.signup.eyebrow')}
        </span>
        <span className="h-px w-10 bg-border" aria-hidden />
      </div>

      <div className="space-y-2">
        <p className="text-sm text-muted-foreground">
          {t('invite.signup.partnerLeadIn')}
        </p>
        <h1
          className="text-3xl md:text-4xl font-bold tracking-tight leading-tight bg-gradient-to-r from-emerald-600 via-green-500 to-emerald-600 bg-clip-text text-transparent break-words"
          translate="no"
        >
          {organizationName}
        </h1>
      </div>

      {inviterName && (
        <p className="text-xs text-muted-foreground">
          {t('invite.signup.partnerInviterLine', { inviter: inviterName })}
        </p>
      )}
    </header>
  )
}
